import React, { useState } from "react";
import SparkLine from "../sparkline/SparkLine";
import { SparkLineProps } from "../sparkline/SparkLineTypes";

export default function SparkLineAdvanced(props: SparkLineProps) {
  const [expandedChartIndex, setExpandedChartIndex] = useState<number>(
    props.generalProperties?.expandedChartIndex ?? 0
  );

  if (props.isMultipleCharts) {
    return (
      <div className="flex flex-column gap-3">
        <SparkLine
          {...props}
          chartIndex={0}
          advanced
          isExpanded={expandedChartIndex === 0}
          setExpandedChartIndex={setExpandedChartIndex}
          generalProperties={props.generalProperties}
          isMultipleCharts
        />
        {props.multipleCharts.map((chart, index) => (
          <SparkLine
            key={chart.id ?? index}
            {...chart}
            chartIndex={index + 1}
            isExpanded={expandedChartIndex === index + 1}
            setExpandedChartIndex={setExpandedChartIndex}
            advanced
            generalProperties={props.generalProperties}
            isMultipleCharts
          />
        ))}
      </div>
    );
  }
  return <SparkLine {...props} advanced />;
}
